"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isProjectClosedForRevision = isProjectClosedForRevision;
/**
 * Whether a project can start or edit a revision (TC-REV-006).
 * Reads money / project status — not milestone progress markers.
 */
function isProjectClosedForRevision(input) {
    if (input.status === "completed")
        return true;
    const milestones = input.milestones ?? [];
    if (milestones.length === 0)
        return false;
    const allFullyReleased = milestones.every((milestone) => {
        const budget = Math.abs(Number(milestone.budgetAmount || 0));
        const released = Math.abs(Number(milestone.releasedAmount || 0));
        return budget > 0 && released >= budget - 1e-9;
    });
    if (!allFullyReleased)
        return false;
    const invoices = input.invoices ?? [];
    const hasUnpaid = invoices.some((invoice) => {
        const status = String(invoice.status || "").toLowerCase();
        return status === "pending" || status === "draft" || status === "issued";
    });
    return !hasUnpaid;
}
